const Desc = `renditionCreate: Convert from PSD to PNG. ${new Error('To get file path').stack.split('\n')[1].match(/Object(.+)\(https/)[1] || ''}`

const Payload = {
    inputs: [
        {
            href: 'https://skycity-asset.adobedice.com/testing/pits/input/adobe2s.psd',
            storage: 'external'
        }
    ],
    outputs: [
        {
            storage: 'adobe',
            type: 'image/png',
            overwrite: true,
            width: 100,
            compression: 'small'
        }
    ]
}

module.exports = { Payload, Desc }
